import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-483">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-484">
        Wat anderen ervaren
      </h2>

      <p className="mb-6 leading-relaxed" data-id="element-485">
        Meer dan 15.000 hondeneigenaren hebben inmiddels een cursus van
        Stressless Dogs gevolgd. Dit is wat ze zeggen:
      </p>

      <div className="space-y-6 mb-6" data-id="element-486">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-487">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-488">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-489">
              <div className="w-16 h-16 rounded-full bg-blue-500 flex items-center justify-center text-white text-xl font-bold" data-id="element-490">
                A
              </div>
            </div>
            <div data-id="element-491">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-492" />
              <p className="italic" data-id="element-493">
                "De cursus is een echte eye opener. Door hem te volgen krijg ik
                een veel betere band met mijn honden en ga ik ze echt
                begrijpen."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-494">
                - Annemiek De Buyst
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-495">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-496">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-497">
              <div className="w-16 h-16 rounded-full bg-purple-500 flex items-center justify-center text-white text-xl font-bold" data-id="element-498">
                C
              </div>
            </div>
            <div data-id="element-499">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-500" />
              <p className="italic" data-id="element-501">
                "Het is een totaal andere benadering voor het opvoeden van de
                hond. Je leert te kijken naar de lichaamstaal van je hond en
                daarop aan te sluiten. Heel interessant en leerzaam."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-502">
                - Caroline Beelen
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-503">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-504">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-505">
              <div className="w-16 h-16 rounded-full bg-green-500 flex items-center justify-center text-white text-xl font-bold" data-id="element-506">
                V
              </div>
            </div>
            <div data-id="element-507">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-508" />
              <p className="italic" data-id="element-509">
                "Mijn visie op mijn hond is veranderd. Ik heb in deze cursus
                heel anders naar mijn hond leren kijken, waardoor ik sommige
                zaken beter ben gaan begrijpen. Ik vind het een supercursus!"
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-510">
                - Vincent van der Poel, Heemskerk
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-511">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-512">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-513">
              <div className="w-16 h-16 rounded-full bg-yellow-500 flex items-center justify-center text-white text-xl font-bold" data-id="element-514">
                P
              </div>
            </div>
            <div data-id="element-515">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-516" />
              <p className="italic" data-id="element-517">
                "Sinds ik de cursus "Liefdevol Communiceren" volg, voel ik meer
                connectie met mijn honden en kan ik andere honden beter lezen.
                Ik zie nu hoe een hond zich voelt. We ervaren meer rust in
                huis."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-518">
                - Peter C. Crols
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-519">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-520">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-521">
              <div className="w-16 h-16 rounded-full bg-pink-500 flex items-center justify-center text-white text-xl font-bold" data-id="element-522">
                I
              </div>
            </div>
            <div data-id="element-523">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-524" />
              <p className="italic" data-id="element-525">
                "Ik kijk nu ook echt anders naar mijn hond. Waar ik dacht vooral
                een angstige hond te hebben, blijkt zij gewoon heel beleefd te
                zijn. Mijn benadering naar haar toe is daardoor anders."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-526">- Irma</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center" data-id="element-527">
        <div className="flex justify-center items-center space-x-2 mb-2" data-id="element-528">
          <span className="text-yellow-500 text-2xl" data-id="element-529">★★★★★</span>
        </div>
        <p className="text-sm text-gray-600" data-id="element-530">
          Gemiddelde beoordeling op Trustpilot: 4.6 / 5 sterren
        </p>
      </div>
    </section>;
};